<!-- @jordan - I believe that this page is deprecated and no longer used -->
<template>
  <v-content class="container">
    <v-container class="settings__container">
      <v-layout class="mb-2" align-center>
        <h1>{{ $t('settings.title') }}</h1>
        <v-spacer />
      </v-layout>
      <v-card flat class="content-container">
        <v-card-text>
          <v-layout column class="mb-4">
            <v-layout align-center justify-center>
              <v-avatar class="primary">
                <v-icon color="white"> person </v-icon>
              </v-avatar>
              <div class="ml-2">
                <v-layout align-center>
                  {{ currentUser.full_name }}
                  <v-tooltip bottom class="ml-1">
                    <v-icon slot="activator" size="15"> info </v-icon>
                    <span
                      >Please contact us if you wish to change your name</span
                    >
                  </v-tooltip>
                </v-layout>
              </div>
            </v-layout>
          </v-layout>
          <v-layout wrap class="text-xs-left">
            <v-flex xs12 sm4 class="px-2">
              <div class="text-xs-left">Primary Contact Email</div>
              <v-text-field
                solo
                label="Email"
                v-model="currentUser.email"
                class="default-input"
              />
            </v-flex>
            <v-flex xs12 sm4 class="px-2" v-if="isIndividual">
              <div class="text-xs-left">Work Email</div>
              <v-text-field
                solo
                label="Email"
                v-model="currentCompany.business_email"
                class="default-input"
              />
            </v-flex>
            <v-flex xs12 sm4 class="px-2">
              <v-layout class="text-xs-left no-wrap" align-center>
                Contact Method
              </v-layout>
              <v-select
                v-model="currentUser.preferred_contact_method"
                solo
                :items="preferredContactMethods"
                placeholder="Please select a contact method"
                item-text="label"
                item-value="value"
                class="default-input mb-1"
              />
            </v-flex>
            <v-flex xs12 sm4 class="px-2">
              <div class="text-xs-left">Phone Number</div>
              <v-text-field
                solo
                v-model="currentUser.phone_number"
                class="default-input"
                label="(777) 777- 7777"
                mask="phone"
              />
            </v-flex>
            <v-flex xs12 sm4 class="px-2">
              <div class="text-xs-left">Work Phone Number</div>
              <v-text-field
                solo
                v-model="currentUser.work_phone_number"
                class="default-input"
                label="Optional"
                mask="phone"
              />
            </v-flex>
            <v-flex xs12 sm4 class="px-2">
              <div class="text-xs-left">Work Phone Extension</div>
              <v-text-field
                solo
                v-model="currentUser.work_phone_extension"
                class="default-input"
                label="Optional"
              />
            </v-flex>
            <v-flex xs12 sm4 class="px-2" v-if="!isIndividual">
              <div class="text-xs-left">Time Zone</div>
              <v-select
                v-model="currentUser.time_zone"
                solo
                :items="timeZones"
                class="default-input mb-1"
              />
            </v-flex>
          </v-layout>
          <v-divider
            v-if="currentCompany && currentCompany.entity_type !== 'Individual'"
            class="my-4"
          />
          <v-layout column class="mb-4" v-if="!isIndividual">
            <v-layout align-center justify-center>
              <v-avatar class="primary">
                <v-icon color="white"> business </v-icon>
              </v-avatar>
              <div class="ml-2">
                <v-layout align-center>
                  {{ currentCompany ? currentCompany.name : '' }}
                  <v-tooltip bottom class="ml-1">
                    <v-icon slot="activator" size="15"> info </v-icon>
                    <span
                      >Please contact us if you wish to change your business
                      name</span
                    >
                  </v-tooltip>
                </v-layout>
              </div>
            </v-layout>
          </v-layout>
          <v-layout wrap class="text-xs-left" v-if="!isIndividual">
            <v-flex xs12 sm4 class="px-2">
              <div class="text-xs-left">Business Email</div>
              <v-text-field
                solo
                label="Email"
                v-model="currentCompany.business_email"
                class="default-input"
              />
            </v-flex>
            <v-flex xs12 sm4 class="px-2">
              <div>Other Email</div>
              <v-text-field
                placeholder="Optional"
                v-model="currentCompany.other_email"
                solo
                class="default-input"
              />
            </v-flex>
            <v-flex xs12 sm4 class="px-2">
              <div>Fax</div>
              <v-text-field
                placeholder="Optional"
                v-model="currentCompany.fax"
                solo
                class="default-input"
              />
            </v-flex>
            <v-flex xs12 sm12 class="px-2">
              <div class="text-xs-left">Street Address</div>
              <v-text-field
                solo
                label="Street Address"
                v-model="currentCompany.street"
                class="default-input"
              />
            </v-flex>
            <v-flex xs12 sm4 class="px-2">
              <div>City</div>
              <v-text-field
                solo
                label="City"
                v-model="currentCompany.city"
                class="default-input"
              />
            </v-flex>
            <v-flex xs12 sm4 class="px-2">
              <div>State</div>
              <v-autocomplete
                solo
                hide-selected
                label="State"
                v-model="currentCompany.state"
                class="default-input"
                :items="states"
              />
            </v-flex>
            <v-flex sm4 class="px-2">
              <div>ZIP Code</div>
              <v-text-field
                solo
                label="Zip"
                v-model="currentCompany.zip"
                class="default-input"
                type="number"
                mask="#####"
              />
            </v-flex>
          </v-layout>
          <v-layout wrap class="text-xs-left" v-else>
            <v-flex xs12 sm6 class="px-2">
              <div class="text-xs-left">Time Zone</div>
              <v-select
                v-model="currentUser.time_zone"
                solo
                :items="timeZones"
                class="default-input mb-1"
              />
            </v-flex>
            <v-flex xs12 sm6 class="px-2">
              <div class="text-xs-left">Language</div>
              <SwitchLocale v-model="currentUser.language" />
            </v-flex>
            <v-flex xs12 sm12 class="px-2">
              <div class="text-xs-left">Street Address</div>
              <v-text-field
                solo
                label="Street Address"
                v-model="currentCompany.street"
                class="default-input"
              />
            </v-flex>
            <v-flex xs12 sm4 class="px-2">
              <div>City</div>
              <v-text-field
                solo
                label="City"
                v-model="currentCompany.city"
                class="default-input"
              />
            </v-flex>
            <v-flex xs12 sm4 class="px-2">
              <div>State</div>
              <v-autocomplete
                solo
                hide-selected
                label="State"
                v-model="currentCompany.state"
                class="default-input"
                :items="states"
              />
            </v-flex>
            <v-flex sm4 class="px-2">
              <div>ZIP Code</div>
              <v-text-field
                solo
                label="Zip"
                v-model="currentCompany.zip"
                class="default-input"
                type="number"
                mask="#####"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="px-4">
          <v-switch
            class="default-input ma-0 pa-0"
            v-model="currentUserPreferences.hide_conversation_in_email"
            :true-value="true"
            :false-value="false"
            solo
            hide-details
            label="Hide conversation from email"
          />
        </v-card-actions>
        <v-card-actions class="pb-4 px-4">
          <v-btn
            :block="$vuetify.breakpoint.smAndDown"
            outline
            class="primary--text text-capitalize px-2 mr-2"
            @click="resetPassword"
          >
            {{ $t('settings.resetPassword') }}
          </v-btn>
          <v-spacer class="hidden-xs-only" />
          <v-btn
            :block="$vuetify.breakpoint.smAndDown"
            class="primary text-capitalize"
            @click="save"
          >
            <v-icon left> check </v-icon>
            {{ $t('settings.saveChanges') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import { firebase } from '@firebase/app';
import '@firebase/auth';
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import get from 'lodash/get';
import { timeZones, states } from '@/constants/variables';
import SwitchLocale from '@/components/SwitchLanguage';

export default {
  name: 'Settings',
  data() {
    return {
      previousTitle: '',
      timeZones,
      states,
      preferredContactMethods: [
        {
          label: 'Email & Text',
          value: 'sms',
        },
        {
          label: 'Email',
          value: 'email',
        },
      ],
      currentUserPreferences: {},
      currentCompanyId: null,
      currentCompany: {},
    };
  },
  components: {
    SwitchLocale,
  },
  computed: {
    ...mapGetters({
      currentUser: 'user',
      defaultCompany: 'defaultCompany',
      isAdvisor: 'isAdvisor',
    }),
    isIndividual() {
      return (
        this.currentCompany && this.currentCompany.entity_type === 'Individual'
      );
    },
  },
  methods: {
    get,
    async save() {
      this.$store.commit('application/START_LOADING');
      const {
        name,
        street,
        state,
        city,
        zip,
        user,
        fax,
        other_email,
        business_email,
      } = this.currentCompany;
      const {
        email,
        phone_number,
        preferred_contact_method,
        time_zone,
        work_phone_number,
        work_phone_extension,
        language,
      } = this.currentUser;
      try {
        const response = await API.company.updateCompany({
          id: this.currentCompanyId,
          userId: this.currentUser.id,
          name,
          email,
          street,
          state,
          city,
          zip,
          phone_number,
          work_phone_number,
          work_phone_extension,
          preferred_contact_method,
          time_zone,
          fax,
          other_email,
          business_email,
          language,
          preferences: this.currentUserPreferences,
        });
        await this.$store.dispatch('companies/getCompanies');
        this.$store.dispatch('application/setSuccessNotification', {
          message: 'Information has been saved successfully.',
        });
      } catch (e) {
        this.$store.dispatch('application/setErrorNotification', {
          message: 'Something went wrong while saving information.',
          errorToSend: e,
          userEmail: this.currentUser.email,
        });
      } finally {
        this.$i18n.locale = this.currentUser.language;
        this.$store.dispatch('getCurrentUser');
        this.$store.commit('application/END_LOADING');
      }
    },
    async resetPassword() {
      const auth = firebase.auth();
      const email = this.currentUser.email;

      try {
        await auth.sendPasswordResetEmail(email);
        this.$store.dispatch('application/setSuccessNotification', {
          message: `Reset Email sent to ${email}`,
        });
      } catch (e) {
        console.log(e);
      }
    },
  },
  async created() {
    try {
      if (this.$route.query.companyId) {
        this.currentCompanyId = parseInt(this.$route.query.companyId);
      } else if (this.$route.params.hash) {
        const hash = this.$route.params.hash;
        const hashId = hash.substring(hash.lastIndexOf('-') + 1);
        try {
          const { data } = await API.company.getCompanyIdByHashId(hashId);

          this.currentCompanyId = data.id;
        } catch (error) {
          this.$router.push('/select-entity');
        }
      } else {
        this.currentCompanyId = this.defaultCompany.id;
      }

      const response = await API.company.getCompany(this.currentCompanyId);
      this.currentCompany = response.data;

      this.previousTitle = document.title;
      document.title = this.currentCompany.name;

      await this.$store.dispatch('resetTiles', {
        hashId: this.currentCompany.hash_id,
        clientName: this.currentCompany.name
          .replaceAll(' ', '-')
          .replaceAll(',', '')
          .replaceAll('#', ''),
      });

      this.$store.commit('application/START_LOADING');
      if (this.currentUser.preferences) {
        this.currentUserPreferences = this.currentUser.preferences;
      } else {
        this.currentUserPreferences = {};
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.$store.commit('application/END_LOADING');
    }
  },
};
</script>

<style lang="postcss" scoped>
.container {
  max-width: 1000px;
}
.settings__container {
  max-width: 800px;
  /* display: flex; */
  flex-direction: column;
  align-items: center;
}
</style>
